function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    border-bottom: 1px solid transparent;\n    box-sizing: border-box;\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    margin: 0 ", ";\n    position: relative;\n    text-align: center;\n\n    &:first-child {\n      margin-left: 0;\n    }\n    &:last-child {\n      margin-right: 0;\n    }\n\n    &:hover {\n      border-bottom: 1px solid ", ";\n    }\n\n    &.selected {\n      color: ", ";\n    }\n\n    &.disabled {\n      color: ", ";\n      pointer-events: none;\n\n      ", " {\n        background-color: ", ";\n      }\n    }\n\n    ", " {\n      white-space: nowrap;\n    }\n\n    ", " {\n      position: absolute;\n      bottom: -1px;\n      left: 0;\n      height: 1px;\n      width: 100%;\n      border-radius: 10px;\n      background-color: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { Tab as BaseTab, TabStyles } from "@diana-ui/tab";
var Tab = styled(BaseTab)((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject(), theme.colors.grey.grey100, theme.spaceUnit.sm, theme.colors.grey.grey100, theme.colors.black, theme.colors.grey.grey50, TabStyles.TabBorder, theme.colors.grey.grey50, TabStyles.StyledLabel, TabStyles.TabBorder, theme.colors.black);
});
export default Tab;